import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import cross from "../../../../assets/images/cross.svg";
import memberAdded from "../../../../assets/images/memberAdded.png";
import tradeBellPng from "../../../../assets/images/bellIcon.svg";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
// import "./PayoutSetupModal.css";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import useApi from "../../../../helpers/apiHelper/requestHelper";

const AccountVerificationApiModal = ({
  showDisConnectPopup = {},
  showEmailPopUp = {},
  setShowEmailPopUp,
  onClose,
  disConnectYesAction,
  callApi,
}) => {
  const [otp, setOtp] = useState("");
  const [codeIncorrect, setCodeIncorrect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingPopUp, setShowLoadingPopUp] = useState(false);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [genericText, setGenericText] = useState("");
  const api = useApi();

  // Check if any state is true to show the modal
  const shouldShowModal =
    showDisConnectPopup?.show ||
    showEmailPopUp?.show ||
    showLoadingPopUp ||
    showSuccessPopUp;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShowLoadingPopUp(false);
    setShowSuccessPopUp(false);
    setGenericText("");
  };

  const handleSendCode = async () => {
    setIsLoading(true);

    const response = await api("post", "users/updateAccountOTP");

    if (response?.status) setIsLoading(false);
  };

 const handleVerify = async () => {
  if (!otp || otp.length < 6) {
    setCodeIncorrect(true);
    return;
  }

  const response = await api("post", "users/verifyAccountOTP", {
    otp,
  });

  if (response?.data?.verified) {
    setShowEmailPopUp({ show: false });
    setShowLoadingPopUp(true);

    try {
      // Wait for the API call to complete
      const success = await callApi();
      
      setShowLoadingPopUp(false);
      
      if (success) {
        setShowSuccessPopUp(true);
        // Auto close after 3 seconds
        setTimeout(() => {
          handleClose();
        }, 3000);
      } else {
        // setShowErrorPopUp(true);
        // setErrorMessage("Failed to update email. Please try again.");
      }
    } catch (error) {
      setShowLoadingPopUp(false);
    //   setShowErrorPopUp(true);
    //   setErrorMessage("An error occurred. Please try again.");
    }
  } else {
    setCodeIncorrect(true);
  }
};

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setCodeIncorrect(false); // Reset error when user types
  };

  useEffect(() => {
    setOtp("");
    setCodeIncorrect(false);
    if (showEmailPopUp?.show) {
      handleSendCode();
    }
  }, [showEmailPopUp?.show]);

  useEffect(() => {
    if (otp?.length === 6) {
      handleVerify();
    }
  }, [otp]);

  useEffect(() => {
    if (showDisConnectPopup?.show) {
      setGenericText(showDisConnectPopup?.buttonClick?.toLowerCase());
    }
  }, [showDisConnectPopup]);

  function toVerbIng(text) {
    if (!text) return "";
    const capitalized = text.charAt(0).toUpperCase() + text.slice(1);

    // Handle specific cases for proper spelling
    if (capitalized === "Delete") {
      return "Deleting";
    } else if (capitalized === "Disconnect") {
      return "Disconnecting";
    }

    return capitalized + "ing";
  }

  function toThirldVerb(text) {
    if (!text) return "";
    const capitalized = text.charAt(0).toUpperCase() + text.slice(1);

    // Handle specific cases for proper spelling
    if (capitalized === "Delete") {
      return "deleted";
    } else if (capitalized === "Disconnect") {
      return "disconnected";
    }

    return capitalized + "ing";
  }

  return (
    <div className="VerificationApiModalWrapper">
      <Modal backdrop="false" id="verificationApiModal" show={shouldShowModal}>
        <Modal.Body>
          <div className="modalContent">
            <Button className="closeBtn" onClick={handleClose}>
              <img alt="Close Modal" src={cross} />
            </Button>

            {showLoadingPopUp && (
              <div className="regBox loadingWrap">
                <div className="loading-4">
                  <span className="span1"></span>
                  <span className="span2"></span>
                  <span className="span3"></span>
                </div>
                <p className="redirectingText">
                  <span className="exchangeDeletingText">{`Updating Email `}</span>
                  <br />
                  Please hold…
                </p>
              </div>
            )}

            {showSuccessPopUp && (
              <div className="regBox success important-padding">
                <div className="img-box">
                  <img alt="Success" src={memberAdded} />
                </div>
                <div className="content-box">
                  <p className="popUpMsg">
                    {`Your Email is updated`}
                    <br />
                    {/* <span>Your Email is updated</span> */}
                  </p>
                </div>
              </div>
            )}

            {showEmailPopUp?.show && (
              <div className="regBox apiVerification">
                <div className="content-box">
                  <p className="popUpMsg text-center">
                    Please verify changes
                    <br />
                    <span>Use the code sent to your email</span>
                  </p>
                </div>
                <FloatingTextFiled
                  className={`apiVerificationInput w-100`}
                  forLabel="codeinput"
                  id="codeinput"
                  label="Enter code here"
                  placeholder="Enter code here"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength={6}
                />
                {codeIncorrect && (
                  <p
                    className="text-danger"
                    style={{
                      fontSize: "14px",
                      marginTop: "8px",
                      textAlign: "center",
                    }}
                  >
                    Code incorrect
                  </p>
                )}
                {/* <div style={{ textAlign: "center", marginTop: "12px" }}>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      color: "#007bff",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      if (isLoading) return;
                      handleSendCode();
                    }}
                    disabled={isLoading}
                  >
                    Resend Code
                  </button>
                </div> */}
              </div>
            )}
         
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AccountVerificationApiModal;
